import styles from './account.module.scss';
import { CheckboxLabel, TextField } from '@frontend-workspace/react-shared-lib';
import { dateFormatter } from 'libs/webkua-lib/src/lib/helpers';
import { ILoan } from 'libs/webkua-lib/src/lib/_models/loan';
import { Col, Row } from 'reactstrap';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface AccountProps {
  loan?: ILoan
}

export function Account(props: AccountProps) {
  const { t } = useTranslation();
  return (
    <Row>
      <Col md={8} xxl={6}>
        <div className="d-flex flex-column mb-3">
          <TextField
            value={props.loan?.user?.email || ''}
            fullWidth
            label={t("standard.email")}
            disabled
            className='mb-3'
          />
          <TextField
            value={props.loan?.userId || ''}
            fullWidth
            label={t("standard.accountID")}
            disabled
            className='mb-3'
          />
          <TextField
            value={dateFormatter(props.loan?.user?.createdTime)}
            fullWidth
            label={t("standard.created")}
            disabled
            className='mb-3'
          />
        </div>
      </Col>
      <Col md={4} xxl={6}>
        <div className="d-flex flex-column mb-3">
          <CheckboxLabel
            label={t("standard.blocked")}
            checked={props.loan?.user?.isBlocked}
            disabled={true}
          />
          <CheckboxLabel
            label={t("standard.student")}
            checked={props.loan?.user?.isStudent}
            disabled={true}
          />
        </div>
      </Col>
    </Row>
  );
}

export default Account;
